<template>
  <div class="course-evaluate-list" v-if="evaluateList && evaluateList.createTime">
    <van-collapse v-model="activeEvaluateNames" accordion>
      <van-collapse-item name="1" ref="collapseItemRef">
        <template #title>
          <div class="title-container">
            <div class="evaluate-title">
              <span class="title">课程评价</span>
            </div>
          </div>
        </template>
        <div class="evaluate-content">
          <div class="triangle-left"></div>
          <div class="triangle-right"></div>
          <div class="content">
            <div class="answer">
              <div class="answer-title">1.您会将此课程推荐给其他人吗？</div>
              <div class="start-block">
                <div class="block-txt" :class="evaluateList.score === index ? 'cur' : ''" v-for="(item, index) in 11" :key="index">{{ item - 1 }}</div>
              </div>
              <div class="start-txt">
                <div class="start-txt1">不推荐</div>
                <div class="start-txt1">极其推荐</div>
              </div>
            </div>
            <div class="answer">
              <div class="answer-title">2.您期待的课程时长为？</div>
              <van-radio-group v-model="evaluateList.courseRadio" direction="horizontal" icon-size="16px"
                checked-color="#EB1700" readonly>
                <van-radio v-for="(item, index) in courseLength" :key="index" :name="index">{{ item }}min</van-radio>
              </van-radio-group>
            </div>
            <div class="answer">
              <div class="answer-title">3.您对课程内容的建议？</div>
              <div class="txt">{{ evaluateList.content }}</div>
            </div>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
export default {
  name: 'CourseEvaluateList',
  props: {
    evaluateList: {
      type: Object
    }
  },
  data () {
    return {
      activeEvaluateNames: ['1'],
      courseLength: ['5', '10', '15', '20']
    }
  },
  watch: {
    evaluateList (newVal) {
      this.evaluateList = newVal
      if (Object.keys(this.evaluateList).length <= 0) return
      this.courseLength.map((res, index) => {
        if (this.evaluateList.courseLength + '' === res) {
          this.evaluateList.courseRadio = index
        }
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang="less" scoped>
.course-evaluate-list {
  padding: 16px 12px 0;

  .title-container {
    display: flex;
    align-items: center;

    .evaluate-title {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;

      .title {
        font-size: 14px;
        font-weight: bold;
        color: #1f333f;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .tips {
        float: right;
        font-size: 11px;
        color: #6d6d6d;
      }
    }
  }

  .evaluate-content {
    position: relative;

    .triangle-left {
      position: absolute;
      left: -5px;
      width: 5px;
      height: 5px;
      background: #999999;
      background: linear-gradient(45deg,
          transparent,
          transparent 50%,
          #999 51%,
          #999 100%);
    }

    .triangle-right {
      position: absolute;
      right: -5px;
      width: 5px;
      height: 5px;
      background: linear-gradient(-45deg,
          transparent,
          transparent 50%,
          #999 51%,
          #999 100%);
    }
  }

  .content {
    padding: 15px 0;
    box-sizing: border-box;
  }

  .answer {
    padding: 0 18px;
    margin-bottom: 15px;
    box-sizing: border-box;

    .answer-title {
      font-size: 14px;
      color: #000000;
      line-height: 20px;
      margin-bottom: 7px;
      font-weight: 400;
    }

    .start-block {
        display: flex;
        justify-content: space-between;

        .block-txt {
          width: 24px;
          height: 28px;
          text-align: center;
          line-height: 28px;
          border-radius: 2px;
          border: 1px solid #D8D8D8;
          font-size: 13px;
          color: #2B2B2B;
          box-sizing: border-box;
          &.cur {
            border-color: #EB1700;
            background-color: rgba(254, 91, 0, 0.10);
            color: #EB1700;
          }
        }

        .score {
          color: #999;
          font-size: 14px;
          margin-left: 50px;
        }
      }
      .start-txt {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 11px;
        color: #B9B7B7;
        margin-top: 5px;
      }

    /deep/ .van-radio--horizontal {
      width: 33%;
      margin-top: 5px;
    }

  }

  /deep/ .van-collapse-item__wrapper {
    box-shadow: 2px 3px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 0 0 5px 5px;
  }

  /deep/ .van-cell {
    line-height: normal;
    display: flex;
    align-items: center;
    height: 44px;
    background: #fff;
    box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.04);
    border-radius: 12px;
  }

  /deep/ .van-collapse-item__title--expanded {
    overflow: auto;
    border-radius: 12px 12px 0 0;
  }

  /deep/ .van-collapse-item__content {
    margin: 0 5px;
    padding: 0;
    background: #fff;
    box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.04);
    border-radius: 0 0 5px 5px;
  }
}</style>



// WEBPACK FOOTER //
// src/views/course/components/CourseEvaluateList.vue